module.exports = __webpack_public_path__ + "components/flag/static/square/ba-b37d63433afed0c9f5082ae7254dd2b0.svg";